import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IErrorContent } from '../../common/components/modals/error-modal/error-modal.component';

@Injectable({ providedIn: 'root' })
export class ErrorsService {
  public isShowError$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public errorContentList: IErrorContent[] = [];
}
